import { Button as AntButton, ButtonProps } from "antd";
import styled from "styled-components";

export const Button: typeof AntButton = styled(AntButton)<ButtonProps>``;
